export default __webpack_public_path__ + "fonts/ad0c5cf95777edc9bb8e8f60bad5ee42.eot";